import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import useFormValidator from 'useFormValidator';
import { ModalContext } from 'App';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import { InputTemplate } from "modules/common/components/inputComponents";

import * as actions from '../actions';
import * as c from '../constant';

function VerifyConfirmationModal({
  verify,
  verifyRenewal,
  verifying,
  verifyingRenewal,
  formData,
  setFormData,
  id,
  trackingNo,
  getItem,
  refreshList,
  transactionType,
}) {
  const setModal = useContext(ModalContext);
  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      amount: formData.amount,
    };
    if (transactionType === 'RENEWAL'){
      return verifyRenewal(id, args, () => {
        setModal({ isOpen: false });
        refreshList(id);
        getItem(id);
      })
    } 
    return verify(id, args, () => {
      setModal({ isOpen: false });
      refreshList(id);
      getItem(id);
    })
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    setFormData({
      ...formData,
      tracking_no: trackingNo,
      year: new Date().getFullYear(),
    });
  }, []);

  const formValidation = {};

  const validateForm = useFormValidator(formData, formValidation);
  
  useEffect(() => {
    validateForm.onSetObjectRules(formValidation);
  }, [formData]);
  
  const onChange = e => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const handleOnChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="full-group-v2">
          <div className="form-row">
            <InputTemplate
              // isInputMask
              title="Tracking No."
              htmlFor="tracking_no"
              containerClassName="col-12"
              // formValidatorMsg={validateForm.renderMessage("tracking_no")}
              // Input component props
              placeholder=""
              // className="full-input-v2 text-uppercase"
              className="full-input-v2"
              id="tracking_no"
              name="tracking_no"
              type="text"
              autoComplete="none"
              onChange={onChange}
              value={_.get(formData, 'tracking_no')?.toUpperCase() || ''}
              disabled
            />
            <InputTemplate
              title="Year"
              htmlFor="year"
              containerClassName="col-12"
              withCustomInputComponent={() => (
                <DateInputPicker
                  showYearPicker
                  inputClassName="full-input form-input-record-v2"
                  placeholder="YYYY"
                  btnClassName="button-date2-v2 cms-bg-color-secondary cms-outline-secondary"
                  onChange={handleOnChangeDate('year')}
                  value={_.get(formData, 'year')?.toString() || ""}
                  disabled
                />
              )}
            />

          </div>
          <div className="mt-2 pt-2 d-flex col-12 cms-text-primary cms-bg-color-primary-light">
            <p>Are you sure you want to confirm the approval of this application? This will be sent to the Planning Department Officer to their assessment.</p>
          </div>
          <div className="d-flex justify-content-end">
            <button
              disabled={verifying || verifyingRenewal}
              type="submit"
              className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
            >
              <span className="font-weight-bold">
                {verifying || verifyingRenewal ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
              </span>
            </button>
            <button
              disabled={verifying || verifyingRenewal}
              type="button"
              onClick={closeModal}
              className="mt-3 btn btn-default"
            >
              <span className="font-weight-bold">Cancel</span>
            </button>
          </div>
        </div>
      </form>
    </Modal.Body>
  );
}

VerifyConfirmationModal.propTypes = {
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  verify: PropTypes.instanceOf(Function).isRequired,
  verifying: PropTypes.bool.isRequired,
  verifyRenewal: PropTypes.instanceOf(Function).isRequired,
  verifyingRenewal: PropTypes.bool.isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  refreshList: PropTypes.instanceOf(Function).isRequired,
  trackingNo: PropTypes.string.isRequired,
  transactionType: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  verifying: api.loading.indexOf(c.VERIFY) > -1,
  verifyingRenewal: api.loading.indexOf(c.VERIFY_RENEWAL) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(VerifyConfirmationModal);
